/**
 * Patient Import Store Hooks
 *
 * Re-exports generated data-migration hooks with user-friendly names.
 * The verbose codegen names (e.g. useProviderGetProposedSchemaQuery) are
 * never exposed outside this module.
 */

import { patientImportApi, useUploadPatientImportFileMutation } from './api';

// ---------------------------------------------------------------------------
// Destructure generated hooks from the enhanced API
// ---------------------------------------------------------------------------

const {
  useProviderListImportSessionsQuery,
  useGetExtractedPatientsForReviewQuery,
  useApproveCsvImportMutation,
  useProviderGetImportSessionStatusQuery,
  useProviderDeleteImportSessionMutation,
} = patientImportApi;

// ---------------------------------------------------------------------------
// Re-export with user-friendly names
// ---------------------------------------------------------------------------

export {
  useApproveCsvImportMutation as useApproveImportMutation,
  useProviderDeleteImportSessionMutation as useDeleteImportSessionMutation,
  useGetExtractedPatientsForReviewQuery as useGetExtractedPatientsQuery,
  useProviderGetImportSessionStatusQuery as useGetImportSessionStatusQuery,
  useProviderListImportSessionsQuery as useListImportSessionsQuery,
  useUploadPatientImportFileMutation as useUploadImportFileMutation,
};
